import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { SectionHeader } from './SectionHeader';
export function Merch() {
  return <section id="merch" className="py-24 md:py-32 px-6 md:px-12 max-w-screen-2xl mx-auto" data-id="element-42" data-mp="1ze557f6sevd7">
      <SectionHeader number="05" title="Merch" data-id="element-43" data-mp="1lj2ywqy133zv" />

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="flex flex-col items-center justify-center text-center py-24 md:py-32 border border-brand-white/10" data-id="element-44" data-mp="1qguqtkyoaq42">
        <div className="w-20 h-20 rounded-full border border-brand-white/20 flex items-center justify-center mb-8" data-id="element-45" data-mp="24et38ktfocgx">
          <ShoppingBagIcon className="w-8 h-8 text-brand-muted" data-id="element-46" data-mp="29d49ymofm6ux" />
        </div>
        <h3 className="font-display text-3xl md:text-5xl text-brand-white uppercase tracking-widest mb-4" data-id="element-47" data-mp="2x38d6sxpk4le">
          No Merchandise
        </h3>
        <p className="text-brand-muted text-sm md:text-base tracking-widest uppercase max-w-md" data-id="element-48" data-mp="31wt6w8s9qces">
          No merchandise at the moment. Check back soon for new drops.
        </p>
      </motion.div>
    </section>;
}